module.exports = __webpack_public_path__ + "img/0.73555a4c.jpg";